/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Slide3description1Inputs */

const he_extension_slide3description1 = /** @type {(inputs: Extension_Slide3description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קבלו התראות על ירידות מחירים ומועדי רכישה אופטימליים`)
};

const en_extension_slide3description1 = /** @type {(inputs: Extension_Slide3description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get alerts for price drops and optimal purchase timing`)
};

/**
* | output |
* | --- |
* | "Get alerts for price drops and optimal purchase timing" |
*
* @param {Extension_Slide3description1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_slide3description1 = /** @type {((inputs?: Extension_Slide3description1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Slide3description1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_slide3description1(inputs)
	return en_extension_slide3description1(inputs)
});
export { extension_slide3description1 as "extension_slide3Description" }